import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FloatingLabel, Form } from "react-bootstrap";
import { TalukServices } from "../../../services/Taluk";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../components/LoadingModal.js";
import AlertModal from "../../../components/AlertModal.js";
import styles from "../../../styles/Modal.module.css";

function AddTaluk(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [taluk, setTaluk] = useState({ taluk: "" });
  const [error, setError] = useState({ taluk: "" });

  // Alert state
  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const validation = () => {
    let tempError = { taluk: "" };
    let valid = true;
    if (!taluk.taluk.trim()) {
      tempError.taluk = "Taluk is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const saveTaluk = async () => {
    if (!validation()) return;
  
    setLoading(true);
    try {
      const res = await TalukServices.addTaluk(taluk);
      if (res.status === 200) {
        setTaluk({ taluk: "" });
        props.onHide();                  
        props.onClose && props.onClose({ 
          status: "success",
          message: res.message || "Taluk added successfully!"
        });
      } else {
        throw new Error(res.message || "Error while adding Taluk");
      }
    } catch (error) {
      props.onClose && props.onClose({
        status: "error",
        message: error.message || "Failed to add Taluk. Please try again."
      });
    } finally {
      setLoading(false);
    }
  };
  

  const handleAlertClose = () => {
    setAlertData((prev) => ({ ...prev, show: false }));
    if (alertData.variant === "success") {
      navigate("/taluk");
    }
  };

  return (
    <>
      {/* Add Taluk Modal */}
      <Modal {...props} size="md" centered className={styles.modalShow}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            <i className="fas fa-plus-circle me-2"></i>
            Add New Taluk
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="taluk"
              label={
                <>
                  Taluk <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Control
                type="text"
                placeholder="Enter Taluk"
                value={taluk.taluk}
                onChange={(e) => setTaluk({ ...taluk, taluk: e.target.value })}
                isInvalid={!!error.taluk}
              />
              <Form.Control.Feedback type="invalid">
                {error.taluk}
              </Form.Control.Feedback>
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button
            variant="success"
            onClick={saveTaluk}
            className={styles.primaryButton}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save me-1"></i>
                Save Taluk
              </>
            )}
          </Button>
          <Button
            variant="danger"
            onClick={props.onHide}
            className={styles.secondaryButton}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      <AlertModal
        show={alertData.show}
        onHide={handleAlertClose}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
      />
    </>
  );
}

export default AddTaluk;
